export default __webpack_public_path__ + "static/media/fastlane_detail8.d4e4bf2b.jpg";